<template>
  <div class="view contentBody">
    <p class="title"><span>分红方案</span></p>
    <div class="mb20">
      <el-button type="primary" size="small" @click="planEdit(0)">添加方案</el-button>
    </div>
    <div class="table_wrap">
      <el-table :data="tableData" style="width: 100%">
        <el-table-column prop="name" label="方案名称" width="200"></el-table-column>  
        <el-table-column prop="ratio" label="分红比例（%）"></el-table-column>
        <el-table-column prop="price" label="金额"></el-table-column>
        <el-table-column prop="goods_list" label="包含项目">
          <template slot-scope="scope">
              <el-tooltip placement="right">
                <div slot="content">
                  <p v-for="(item, index) in scope.row.goods_list" :key="index">{{item}}</p>
                </div>
                <el-button type="text">关联{{scope.row.goods_cnt}}个项目</el-button>
              </el-tooltip>
            </template>
        </el-table-column>
        <el-table-column prop="partner_multiple" label="合伙人消费合伙人获取积分倍数" width="200"></el-table-column>
        <el-table-column prop="customer_multiple" label="好友消费合伙人获取积分倍数" width="200"></el-table-column>
        <el-table-column prop="parent_multiple" label="好友消费好友获取积分倍数"></el-table-column>
        <el-table-column prop="create_time_text" label="创建时间"></el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="scope">
            <div class="templateSpan">
              <span class="action_btn" @click="planEdit(1,scope.row.id)">编辑</span>
              <span class="action_btn" @click="pfplan(scope.row.id,scope.row.name)">派发</span>
              <span class="action_btn" @click="handleBtn(scope.row.id)">删除</span>  
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pag_wrap">
      <el-pagination
              background
              @current-change="pageIndexChange"
              :page-size="page.page_size"
              :current-page="page.current_page"
              layout="total, prev, pager, next"
              :total="page.total"></el-pagination>
    </div>
  </div>
</template>

<script>
import api from "@/api.js";
import { pagination } from "@/util/util.js";
export default {
  name: "scheme",
  filters: {//限制文本显示字数,超出部分用...代替
    ellipsis (value) {
        if (!value) return ''
        if (value.length > 25) {
          return value.slice(0,25) + '...'
        }
        return value
    },
  },
  data() {
    return {
      tableData: [],
      page: {
        current_page: pagination.pageIndex,
        page_size: pagination.pageSize,
        total_rows: pagination.total_rows
      },
      dialogTableVisible: false,
      schemecordData: [],
    }
  },
  created() {
    this.initFn();
  },
  methods: {
    initFn() {
      this.axios
        .post(api.partner_schemeList, {page: this.page.pageindex})
        .then(response => {
          if (response.data.code == 0) {
            this.tableData = response.data.result;
           this.page.total = response.data.page.total_rows//总条数
          } 
        })
        .catch(() => {});  
    },
    pageIndexChange(pageindex) {
      this.page.pageindex = pageindex;
      this.initFn();
    },

    planEdit(type, id) {
      this.$router.push({name: "planEdit", query: {id: id, type: type}});
    },
    pfplan(id,name) {
      this.$router.push({name: "pfplan", query:{option:id,value:name}});
    },
    
    //删除
    handleBtn(id){
      this.$confirm('是否确定进行该操作?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
          }).then(() => {
              this.axios
              .post(api.partner_schemeDel ,{scheme_id:id})
              .then(res=>{
                if(res.data.code == 0){
                  this.$message.success(res.data.msg);
                  // this.btnDisabled = false
                  this.initFn();
                }
              }).catch(res => {});
          })
          .catch(() => {
            // this.btnDisabled = false
            this.$message({
                type: 'info',
                message: '您已取消删除'
            });          
        });   
    },
    //停用
    stopBtn(id,status){
      this.axios
        .post(api.partner_changeStatus, {partner_id:id,status:status})
        .then(response => {
          if (response.data.code == 0) {
            this.$message({
              message: "禁用成功",
              type: "success"
            });
            this.querylist();
          } else {
          }
        })
        .catch(() => {});

    },

  }
}
</script>